import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'urql';
import PageHeader from '@/components/common/PageHeader.jsx';
import {
  M_AJUSTAR_LIQUIDACION_CHOFER,
  M_CERRAR_LIQUIDACION_CHOFER,
  M_GENERAR_LIQUIDACION_CHOFER,
  M_MARCAR_PAGADA_LIQUIDACION_CHOFER,
  Q_LIQUIDACION_DETALLE,
} from '@/graphql/choferLiquidaciones.gql.js';

export function exportLiquidacionPDF() {
  // TODO: implementar exportación PDF
  throw new Error('TODO: exportLiquidacionPDF pendiente');
}

export default function LiquidacionChoferDetallePage() {
  const { id } = useParams();
  const [result, refresh] = useQuery({ query: Q_LIQUIDACION_DETALLE, variables: { id: Number(id) } });
  const [, ajustar] = useMutation(M_AJUSTAR_LIQUIDACION_CHOFER);
  const [, cerrar] = useMutation(M_CERRAR_LIQUIDACION_CHOFER);
  const [, pagar] = useMutation(M_MARCAR_PAGADA_LIQUIDACION_CHOFER);
  const [, regenerar] = useMutation(M_GENERAR_LIQUIDACION_CHOFER);
  const liq = result.data?.liquidacionDetalle;
  const [adicionales, setAdicionales] = useState(0);
  const [descuentos, setDescuentos] = useState(0);
  const [notas, setNotas] = useState('');

  if (!liq) return <div>Cargando...</div>;

  const onAjustar = async () => {
    await ajustar({ input: { id: Number(id), adicionales: Number(adicionales), descuentos: Number(descuentos), notas } });
    refresh({ requestPolicy: 'network-only' });
  };

  const onRegenerar = async () => {
    if (!window.confirm('Se regenerarán los items y snapshot. ¿Continuar?')) return;
    await regenerar({ input: { sucursal_id: liq.sucursal_id, chofer_id: liq.chofer_id, periodo_desde: liq.periodo_desde, periodo_hasta: liq.periodo_hasta, reemplazar_borrador: true } });
    refresh({ requestPolicy: 'network-only' });
  };

  return (
    <div className="flex flex-col gap-4">
      <PageHeader title={`Liquidación #${liq.id}`} description={`Chofer ${liq.chofer_id} · ${liq.periodo_desde} a ${liq.periodo_hasta}`} breadcrumbs={[{ label: 'Tesorería', href: '/tesoreria' }, { label: 'Liquidaciones choferes', href: '/tesoreria/choferes/liquidaciones' }, { label: `#${liq.id}` }]} />
      <section className="rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.75)] p-4">
        <div className="grid grid-cols-4 gap-3 text-sm">
          <div>Estado: <span className="rounded-full bg-[rgba(var(--brand),0.14)] px-2 py-1 text-xs text-[rgb(var(--brand))]">{liq.estado}</span></div>
          <div>KM: {liq.total_km}</div>
          <div>Horas: {liq.total_horas}</div>
          <div>Entregas: {liq.total_entregas}</div>
        </div>
        <div className="mt-3 grid grid-cols-3 gap-3">
          <input type="number" step="0.01" value={adicionales} onChange={(e) => setAdicionales(e.target.value)} className="rounded-lg border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2 text-sm" placeholder="Adicionales" />
          <input type="number" step="0.01" value={descuentos} onChange={(e) => setDescuentos(e.target.value)} className="rounded-lg border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2 text-sm" placeholder="Descuentos" />
          <input value={notas} onChange={(e) => setNotas(e.target.value)} className="rounded-lg border border-[rgba(var(--border),0.6)] bg-transparent px-3 py-2 text-sm" placeholder="Notas" />
        </div>
        <button onClick={onAjustar} className="mt-3 rounded-xl border border-[rgba(var(--border),0.8)] px-3 py-2 text-sm">Guardar ajustes</button>
      </section>

      <section className="overflow-auto rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.75)]">
        <table className="min-w-full text-sm">
          <thead><tr className="text-left"><th className="px-3 py-2">Fecha</th><th>Ref</th><th>KM</th><th>Horas</th><th>Entregas</th><th>Monto</th></tr></thead>
          <tbody>{liq.items.map((it) => <tr key={it.id} className="border-t border-[rgba(var(--border),0.4)]"><td className="px-3 py-2">{String(it.fecha).slice(0, 10)}</td><td>{it.referencia_tipo} #{it.referencia_id}</td><td>{it.km}</td><td>{it.horas}</td><td>{it.entregas}</td><td>${it.monto}</td></tr>)}</tbody>
        </table>
      </section>

      <div className="sticky bottom-2 flex gap-2 rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.95)] p-3">
        <button onClick={async () => { await cerrar({ id: Number(id), notas }); refresh({ requestPolicy: 'network-only' }); }} className="rounded-xl bg-[rgb(var(--brand))] px-3 py-2 text-sm text-white">Cerrar</button>
        <button onClick={async () => { await pagar({ id: Number(id) }); refresh({ requestPolicy: 'network-only' }); }} className="rounded-xl border border-[rgba(var(--border),0.8)] px-3 py-2 text-sm">Marcar pagada</button>
        {liq.estado === 'BORRADOR' ? <button onClick={onRegenerar} className="rounded-xl border border-[rgba(var(--border),0.8)] px-3 py-2 text-sm">Regenerar</button> : null}
      </div>
    </div>
  );
}
